import { FormattedMessage } from 'react-intl';

const PremiumSupport = () => {
	return (
		<div>
			<p>
				<FormattedMessage
					id="JiraSoftwarePricingPageTeam24.features.premiumSupport.content.body"
					defaultMessage="1-hr response time for critical issues from Cloud support team."
				/>
			</p>
		</div>
	);
};

export default PremiumSupport;
